import React, { useState } from "react";
import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export function ClickableAvatar({
  src,
  name,
  className = "h-8 w-8 border border-border",
  fallbackClassName = "bg-primary/10 text-primary text-xs font-heading",
  dialogTitle,
}) {
  const [open, setOpen] = useState(false);

  // Compute final image URL
  const imageUrl = src
    ? src.startsWith("http://") || src.startsWith("https://") || src.startsWith("data:")
      ? src
      : `${BACKEND_URL}${src.startsWith("/") ? "" : "/"}${src}`
    : null;

  const handleClick = (e) => {
    if (imageUrl) {
      e.stopPropagation();
      setOpen(true);
    }
  };

  const titleText = dialogTitle || name || "Photo Viewer";

  return (
    <>
      <div
        onClick={handleClick}
        className={imageUrl ? "cursor-zoom-in" : "cursor-default"}
        title={imageUrl ? "View photo" : undefined}
      >
        <Avatar className={`${className} transition-opacity ${imageUrl ? "hover:opacity-80" : ""}`}>
          {imageUrl ? (
            <AvatarImage src={imageUrl} alt={name || "Avatar"} />
          ) : null}
          <AvatarFallback className={fallbackClassName}>
            {name?.[0]?.toUpperCase() || "?"}
          </AvatarFallback>
        </Avatar>
      </div>

      {imageUrl && (
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogContent className="bg-card border-border max-w-sm p-4" onClick={(e) => e.stopPropagation()}>
            <DialogHeader>
              <DialogTitle className="font-heading text-base">
                {titleText}
              </DialogTitle>
            </DialogHeader>
            <div className="flex items-center justify-center mt-2">
              <img
                src={imageUrl}
                alt={name || "Avatar"}
                className="rounded-sm max-h-80 w-full object-contain border border-border"
              />
            </div>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}
